import { NavLink, Outlet } from "react-router-dom";
import { useUser } from "../../lib/auth";

const subNavStyles = ({ isActive }: { isActive: boolean }) =>
  `block rounded-md px-3 py-1.5 text-sm ${
    isActive
      ? "bg-slate-900 text-white"
      : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
  }`;

/** Admin sub-nav layout: left rail of admin sub-pages + outlet for the active one. Admins only. */
export function AdminLayout() {
  const { user } = useUser();
  if (user?.role !== "admin") {
    return (
      <div className="rounded-lg border border-rose-200 bg-rose-50 p-6 text-rose-900">
        <h2 className="text-base font-semibold">Forbidden</h2>
        <p className="mt-1 text-sm">
          You need the admin role to view this area.
        </p>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-[180px_1fr] gap-6">
      <nav className="flex flex-col gap-1">
        <p className="mb-2 px-3 text-xs font-semibold uppercase tracking-wide text-slate-500">
          Admin
        </p>
        <NavLink to="/admin" end className={subNavStyles}>
          Overview
        </NavLink>
        <NavLink to="/admin/users" className={subNavStyles}>
          Users
        </NavLink>
        <NavLink to="/admin/usage" className={subNavStyles}>
          Usage
        </NavLink>
        <NavLink to="/admin/quotas" className={subNavStyles}>
          Quotas
        </NavLink>
        <NavLink to="/admin/audit" className={subNavStyles}>
          Audit log
        </NavLink>
        <NavLink to="/admin/tokens" className={subNavStyles}>
          Tokens
        </NavLink>
        <NavLink to="/admin/cdn-allowlist" className={subNavStyles}>
          CDN allowlist
        </NavLink>
        <NavLink to="/admin/sharing-settings" className={subNavStyles}>
          Sharing
        </NavLink>
        <NavLink to="/admin/lifecycle" className={subNavStyles}>
          Lifecycle
        </NavLink>
        <NavLink to="/admin/feedback" className={subNavStyles}>
          Feedback
        </NavLink>
        <NavLink to="/admin/bigquery" className={subNavStyles}>
          BigQuery
        </NavLink>
        <NavLink to="/admin/jira" className={subNavStyles}>
          Jira
        </NavLink>
        <NavLink to="/admin/alerts" className={subNavStyles}>
          Alerts
        </NavLink>
      </nav>
      <div>
        <Outlet />
      </div>
    </div>
  );
}
